import React from "react";

const Home = () => {
  return (
    <div>
      <p>안녕하세요!</p>
      <p>
        Pacemaker 사용법을 알려드릴게요.
        <br />
        현재 프로필은 구현되어 있지 않습니다.
        <br />
        빠른 시일 내로 업데이트 하고 공지하도록 하겠습니다.
        <br />
        문제 풀기는 <br />
        1. 과목을 선택하고 <br />
        2. 시험을 선택하고 <br />
        3. 문항 번호를 선택하면 됩니다.
      </p>
      <p>
        문항 번호는 하단 슬라이드를 조절하여 고를 수 있습니다.
        <br />
        킬러와 비킬러를 대략적으로 구분하여 풀 수 있을겁니다.
        <br />
        유형별 풀이는 추후 업데이트 될 예정입니다.
        <br />
        이후 문제풀기를 누르면 빈 캔버스가 나올겁니다.
        <br />
        당황하지 마시고 중하단 '시작' 버튼을 누르시면 됩니다.
        <br />
      </p>
      그러면 다들 열공하길 바랍니다!
      <p>
        혹시 추가하고 싶은 기능이 있다거나 하면{" "}
        <a href="https://open.kakao.com/o/s3gKxO2b">카카오톡</a>으로 보내주세요
      </p>
    </div>
  );
};
export default Home;
